<template>
    <div class="wrapper">
        <div class="head">
            <van-nav-bar title="在线支付" />
        </div>
        <div class="content">
            <div class="inp">
                <div class="item tel" v-if="!userTel && type !== '2'">
                    <p class="title">手机号</p>
                    <p><input type="number" v-model="valueTel" placeholder="请输入手机号" /></p>
                    <!--                <van-field  label="手机号" readonly clickable :value="valueTel" @touchstart.native.stop="handleShowTel" placeholder="请输入手机号"/>-->
                    <!--                <van-number-keyboard v-model="valueTel" :show="showTel" close-button-text="完成" theme="custom"  @blur="showTel = false"/>-->
                </div>
                <div class="item">
                    <p class="title">输入金额</p>
                    <p><input type="number" v-model="valuePrice" placeholder="请输入金额" /></p>
                </div>
                <div class="balance">
                    <p v-show="type === '2'">
                        可使用余额<span>￥{{balance}}</span>
                    </p>
                </div>
            </div>

            <div class="option">
                <p class="text">
                    <span>选择支付方式</span>
                </p>
                <div class="option-box">
                    <div class="option-item">
                        <div class="icon-img">
                            <img src="../assets/img/icon/weixinzhifu.png" alt="">
                        </div>
                        <div class="title" @click="type = '0'">微信支付</div>
                        <div class="radio">
                            <van-radio-group v-model="type">
                                <van-radio name="0"></van-radio>
                            </van-radio-group>
                        </div>
                    </div>
                    <div class="option-item">
                        <div class="icon-img">
                            <img src="../assets/img/icon/huiyuankachongzhi.png" alt="">
                        </div>
                        <div class="title" @click="type = '2'">会员卡支付</div>
                        <div class="radio">
                            <van-radio-group v-model="type">
                                <van-radio name="2"></van-radio>
                            </van-radio-group>
                        </div>
                    </div>
                    <div class="option-item">
                        <div class="icon-img">
                            <img src="../assets/img/icon/balance.png" alt="">
                        </div>
                        <div class="title" @click="type = '1'">充值</div>
                        <div class="radio">
                            <van-radio-group v-model="type">
                                <van-radio name="1"></van-radio>
                            </van-radio-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer">
            <van-button type="danger" round size="large" @click="handlePay">立即支付</van-button>
        </div>
    </div>
</template>

<script>
    import {getWxPayService,setDoOrder,balancePayService} from "../service/weChatService";
    import {getUserCardBalanceService} from "../service/userService";
    import {mapState,mapActions} from 'vuex';
    import { Toast,Dialog } from 'vant';
    import {getUrlParamsTools} from "../util/tools";
    import Cookies from 'js-cookie';
    import {isWeixinOrAlipayTools} from '../util/tools';
	//import {wecharShare} from "../util/weChat.js";


    export default {
        name: "Pay",
        data(){
            return{
                valueTel: '',
                valuePrice:'',
                type:"0",//0付款，1充值
                shopId:null,
                balance:0,//可用余额
            }
        },
        created(){
            this.shopId = getUrlParamsTools('shopid');
            const isWeixinOrAlipay = isWeixinOrAlipayTools();

            //微信打开
            if(isWeixinOrAlipay === 'WeiXIN'){
                this.valueTel = this.userTel;
                if(this.valueTel){
                    this.getUserCardBalance();
                }
            }else{
                this.$router.push({
                    name: 'payAlipay',
                    params:{
                        shopId:this.shopId,
                    }
                })
            }
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
        },
        methods:{
            ...mapActions(['setPrice','setUserTel']),

            //获取会员卡余额
            getUserCardBalance(){
                if(!this.shopId){
                    Toast('商家ID不存在，请联系工作人员');
                    return;
                }

                getUserCardBalanceService(this.valueTel,this.shopId).then(res => {
                    if(res.status === 1){
                        this.balance = res.datas || 0;
                    }else {
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            },

            //支付
            handlePay(){
                if(!this.shopId){
                    Toast('商家ID不存在，请联系工作人员');
                    return;
                }
                if(this.valuePrice.length === 0){
                    Toast('请输入金额');
                    return;
                }
                if(this.valuePrice < 0.1){
                    Toast('输入金额有误');
                    return;
                }
                if(this.type === '2'){
                    if(this.balance - this.valuePrice < 0){
                        Toast('您的余额不足，无法支付');
                        return;
                    }
                    this.handleBalancePay();
                }else{
                    if(this.userTel && this.userTel !== '0'){
                        this.valueTel = this.userTel;
                    }else{
                        if(this.valueTel.length !== 11){
                            Toast('请输入手机号');
                            return;
                        }
                    }
                    if(this.valuePrice <= 0){
                        Toast('支付金额输入有误');
                        return;
                    }
                    if (typeof WeixinJSBridge == "undefined"){
                        if( document.addEventListener ){
                            document.addEventListener('WeixinJSBridgeReady', this.handelWechatPay, false);
                        }else if (document.attachEvent){
                            document.attachEvent('WeixinJSBridgeReady', this.handelWechatPay);
                            document.attachEvent('onWeixinJSBridgeReady', this.handelWechatPay);
                        }
                    }else{
                        this.handelWechatPay();
                    }
                }
            },

            //微信支付
            handelWechatPay(){
                getWxPayService(Cookies.get('o_id'),this.shopId,this.valuePrice,this.valueTel,this.type).then(res => {
                    if(res.status === 1){
                        WeixinJSBridge.invoke('getBrandWCPayRequest',{
                            'appId': res.datas.appId, // 公众号名称，由商户传入
                            'timeStamp': res.datas.timeStamp, // 时间戳，自1970年以来的秒数
                            'nonceStr': res.datas.nonceStr, // 随机串
                            'package': res.datas.package,
                            'signType': res.datas.signType, // 微信签名方式：
                            'paySign': res.datas.paySign // 微信签名
                        },result => {
                            if(result.err_msg === 'get_brand_wcpay_request:ok'){
                                localStorage.setItem('u_pay_tel',this.valueTel);
                                setDoOrder(Cookies.get('o_id'),res.datas.wxRecordId,this.shopId,this.type,this.valuePrice,this.valueTel,res.datas.uid).then(res => {
                                    if(res.status === 1){
                                        if(this.type === '1'){//充值
                                            this.getUserCardBalance();
                                            Toast('充值成功');
                                        }else{
                                            if(!this.userTel && this.type !== '2'){
                                                Dialog.alert({
                                                    title:'提示',
                                                    message:'支付成功！\n您已成功注册即刻免费兑换品牌礼品吧！\n账号：' + this.valueTel + '\n初始密码为手机后六位'
                                                }).then(() => {
                                                    this.valuePrice = '';
                                                    this.setUserTel(this.valueTel);
                                                    this.setPrice(res.datas);
                                                    this.$router.push({
                                                        name:'userInfo'
                                                    })
                                                });
                                            }else{
                                                this.valuePrice = '';
                                                this.setUserTel(this.valueTel);
                                                this.setPrice(res.datas);
                                                Dialog.confirm({
                                                    title:'提示',
                                                    message:'支付成功，点击进入公众号'
                                                }).then(() => {
                                                    this.$router.push({
                                                        name:'userInfo'
                                                    })
                                                }).catch(() => {});
                                            }
                                        }
                                    }else{
                                        Toast('支付失败')
                                    }
                                }).catch(err => {
                                    console.log(err);
                                })
                            }else{
                                // Toast(result.err_msg);
                            }
                        })
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            },

            //余额支付
            handleBalancePay(){
                Dialog.alert({
                    title: '是否支付',
                    message: '支付金额：' + this.valuePrice,
                }).then(() => {
                    balancePayService(this.valueTel,this.shopId,this.valuePrice).then(res => {
                        if(res.status === 1){
                            this.balance = (Number(this.balance) - Number(this.valuePrice)).toFixed(2);
                            Dialog.alert({
                                title: '支付成功',
                                message: '支付金额：' + this.valuePrice,
                            }).then(() => {
                                this.valuePrice = '';
                                // on close
                            });
                        }else{
                            Toast(res.msg);
                        }
                    }).catch(err => {
                        console.log(err);
                    })
                })
            }
        },
        computed:{
            ...mapState({
                userId: state => state.userInfo.userId,
                userTel: state => state.userInfo.userTel,
                userPrice: state => state.userInfo.userPrice,
                openId:state => state.userInfo.openId,
            })
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{
        background-color: #ffffff!important;
        .content{
            background-color: #ffffff!important;
            .inp{
                padding: 20px;
                box-sizing: border-box;
                .item{
                    &:nth-child(1){
                        margin-bottom: 20px;
                    }
                    .title{
                        color: #202020;
                        font-size: 14px;
                        margin-bottom: 10px;
                    }
                    input{
                        height: 40px;
                        border:1px solid rgba(208,208,208,1);
                        border-radius:5px;
                        width: 100%;
                        padding: 0 5px;
                        box-sizing: border-box;
                    }
                }
                .balance{
                    margin-top: 5px;
                    height: 20px;
                    span{
                        color: #EF000C;
                    }
                }
            }
            .option{
                .text{
                    padding: 10px 0;
                    border-bottom: 1px solid rgba(240,240,240,1);;
                    span{
                        margin-left: 20px;
                        color: #202020;
                        font-size: 14px;
                    }

                }
                .option-box{
                    padding: 10px 20px;
                    box-sizing: border-box;
                    .option-item{
                        padding: 15px 0;
                        border-bottom: 1px solid rgba(240,240,240,1);;
                        display: flex;
                        align-items: center;
                        .icon-img{
                            flex: 10%;
                            img{
                                width: 25px;
                                height: 25px;
                            }
                        }
                        .title{
                            flex: 80%;
                        }
                        .radio{
                            flex: 10%;
                        }
                    }
                }
            }
        }
        .footer{
            padding: 30px 20px;
            box-sizing: border-box;
        }
    }

</style>
<style scoped>
    .van-button--large{
        height: 40px;
        line-height: 40px
    }
</style>
